import { render, staticRenderFns } from "./IconSelectDate.vue?vue&type=template&id=9970f3ca&scoped=true&"
import script from "./IconSelectDate.vue?vue&type=script&lang=js&"
export * from "./IconSelectDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9970f3ca",
  null
  
)

export default component.exports